module.exports = __webpack_public_path__ + "static/media/RetroSprint1Audio2.68436f66.mp3";